import React from "react";
import { RotateCw } from "lucide-react";

import useGetResources from "../../hooks/useGetResources";
import LoadingSpinner from "../components/LoadingSpinner";
import { Card, CardHeader, CardTitle, CardContent } from "components/ui/card";
import { Button } from "components/ui/button";
import { Spinner } from "components/ui/spinner";
import {
    Table,
    TableHeader,
    TableBody,
    TableRow,
    TableHead,
    TableCell,
} from "components/ui/table";

function Medialive({ eventId, environment, theme }) {
    const { resources, error, isLoaded, refetchResources, isRefetching } = useGetResources(
        eventId,
        environment,
        "get_event_medialive_channels"
    );

    if (!isLoaded) {
        return <LoadingSpinner />;
    }

    function Base64Image({ base64String }) {
        const binaryData = atob(base64String);
        const byteArray = new Uint8Array(binaryData.length);

        for (let i = 0; i < binaryData.length; i++) {
            byteArray[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([byteArray], { type: "image/png" });
        const imageUrl = URL.createObjectURL(blob);

        return <img src={imageUrl} alt="Base64 Image" />;
    }

    return (
        <Card>
            <CardHeader className="flex-row items-center gap-3 space-y-0 border-b border-border">
                <CardTitle className="text-base">Medialive channel</CardTitle>
                <Button
                    size="icon-sm"
                    onClick={refetchResources}
                    title="Refresh"
                    disabled={isRefetching}
                >
                    <RotateCw />
                </Button>
                {isRefetching && <Spinner className="h-4 w-4" />}
            </CardHeader>
            {resources.length > 0 ? (
                getMedialiveTable()
            ) : (
                <CardContent className="pt-4">
                    <p>No Channel found!</p>
                </CardContent>
            )}
        </Card>
    );

    function getMedialiveTable() {
        return (
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>State</TableHead>
                        <TableHead>Channel ID</TableHead>
                        <TableHead>Thumbnail</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {resources.map((resource, index) => (
                        <TableRow key={index}>
                            <TableCell>{resource.name}</TableCell>
                            <TableCell className={getMedialiveColor(resource.state)}>
                                {resource.state}
                            </TableCell>
                            <TableCell>{resource.channelId}</TableCell>
                            <TableCell>
                                <Base64Image base64String={resource.thumbnailBase64} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }
}

export default Medialive;

function getMedialiveColor(state) {
    switch (state) {
        case "RUNNING":
            return "text-success";
        case "STARTING":
            return "text-warning";
        case "TERMINATED":
            return "text-muted-foreground";
        default:
            return "";
    }
}
